module.exports = __webpack_public_path__ + "img/20200507_131821.f1fcb7a6.jpg";